import { getToken, StyleFunctionProps } from "@chakra-ui/react";
import Color from "color";

function getHighContrastColor(
  colorCandidate1: string,
  colorCandidate2: string,
  bgColor: string,
) {
  return Color(colorCandidate1).contrast(Color(bgColor)) >=
    Color(colorCandidate2).contrast(Color(bgColor))
    ? colorCandidate1
    : colorCandidate2;
}

export function getTextOnBrandColor(
  brandingColor: string,
  { theme, colorMode }: Pick<StyleFunctionProps, "theme" | "colorMode">,
) {
  const isDarkMode = colorMode === "dark";

  const textColor = getToken(
    "colors",
    theme.semanticTokens.colors["chakra-body-text"][
      isDarkMode ? "_dark" : "_light"
    ],
  )(theme);
  const bgColor = getToken(
    "colors",
    theme.semanticTokens.colors["chakra-body-bg"][
      isDarkMode ? "_dark" : "_light"
    ],
  )(theme);
  // find out what's a suitable text color for the branded buttons
  return getHighContrastColor(textColor, bgColor, brandingColor);
}
